export default "__VITE_ASSET__BMroB4Nt__"